// extracted by mini-css-extract-plugin
export default {"plot":"WithPlotSelector_plot__WF5Hk","subtitle":"WithPlotSelector_subtitle__WVzQS","code":"WithPlotSelector_code__4FOar","location":"WithPlotSelector_location__-SWul"};